module.exports = __webpack_public_path__ + "media/images/countrysquared/my-1fde62a08980abc51f8a9635bacde1e3.svg";